module.exports = __webpack_public_path__ + "static/media/experience.fc23e019.svg";